@if (isSelectedPointEmpty$ | async) {
  <div class="atlas-panel-body">
    <span i18n="@@selectLocationMessage"
      >Please select a location to view a report</span
      >
    </div>
  }
  @if (areTestStatsAvailable$ | async) {
    <mat-divider></mat-divider>
  }

  @if (areTestStatsAvailable$ | async) {
    <div class="atlas-panel-body">
      <atlas-spatial-modeller-reports-panel></atlas-spatial-modeller-reports-panel>
    </div>
  }
  <mat-divider></mat-divider>
  @if (areTestStatsAvailable$ | async) {
    <atlas-sm-reports-panel-buttons
    ></atlas-sm-reports-panel-buttons>
  }
